<template>
  <a-config-provider :locale="locale" :autoInsertSpaceInButton="false">
    <template #renderEmpty>
      <a-empty image="../static/images/main/img-no-data.png" description="暂无数据"></a-empty>
    </template>
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  
  export default {
    name: 'App',
    data() {
      return {
        // 语言包配置
        locale: zhCN
      };
    }
  }
</script>

<style>
  html,
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
  }
  
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue